import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { myApi } from '../../../config/axiosConfig';
import { PDFDownloadLink, render } from '@react-pdf/renderer';
import { Typography, Grid2, Button, Box, Chip } from '@mui/material';

// ICONOS
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelIcon from '@mui/icons-material/Cancel';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import EditarOperador from './modales/EditarOperador';
import QrDoc from './pdf/QrDoc';

const Operadores = () => {

    // ===========================================
    // FUNCION PARA BUSCAR TRACTORES
    // ===========================================

    const [operadores, setOperadores] = useState([]);

    const buscarOperadores = async () => {

        try {

            const response = await myApi.get('/operadores/catalogo');

            setOperadores(response.data.data);

        } catch(error) {

            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al buscar los operadores.'
            });

        }

    }

    // ===========================================
    // COLUMNAS PARA TABLA
    // ===========================================

    const catalogoChips = {
    
        "true": <Chip label={'Activo'} color="success"/>,
        "false": <Chip label={'Inactivo'} color="error"/>,

    }

    const columns = [

        {
            field: 'driver_code', 
            headerName: 'Driver Code',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'nombre', 
            headerName: 'Operador',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'fleet', 
            headerName: 'Fleet',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'company', 
            headerName: 'Company',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'is_active', 
            headerName: 'Status',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => catalogoChips[params.value],
        },


    ];

    // ===========================================
    // ESTADO PARA MODAL
    // ===========================================

    const [showModal, setShowModal] = useState(false);
    const [formValues, setFormValues] = useState({});

    const handleRowClick = (params) => {

        setFormValues(params.row)
        setShowModal(true)

    }

    // ===========================================
    // FUNCION PARA ACTUALIZAR DATOS DE OPERADORES
    // ===========================================

    const handleUpdateOperadores = async () => {

        Swal.fire({
            title: 'Sincronizando Datos...',
            text: 'Por favor, espera...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        try {

            const response = await myApi.get('operadores/actualizar_operadores');

            if(response.data.success){

                buscarOperadores();

                // Cuando finaliza, mostrar un mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Datos Sincronizados!',
                    timer: 2000,
                    showConfirmButton: false
                });

            }
    
        } catch (error) {

            // Si ocurre un error, mostrar un mensaje de error
            console.log(error);

        }

    }

    // ===========================================
    // USE EFFECT PARA LLAMAR DATOS
    // ===========================================

    useEffect(() => {

        buscarOperadores();

    }, []);

    // ===========================================

    return (

        <Grid2 container>

            {/* HEADER */}

            <Grid2 
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >

                <Typography
                    variant="h4"
                    fontWeight={700}
                >
                    Catalogo Operadores
                </Typography>

                <Box>

                    {/* BOTON PARA ACTUALIZAR DATOS */}

                    <Button
                        variant="contained" 
                        color="secondary"
                        loadingPosition="start"
                        loading={false}
                        startIcon={<SyncIcon/>}
                        sx={{ marginRight: 2 }}
                        onClick={handleUpdateOperadores}
                    >
                        Actualizar Datos
                    </Button>

                    {/* BOTON PARA DESCARGAR QR */}

                    {/* <PDFDownloadLink 
                        document={<QrDoc operadores={operadores} />} 
                        fileName="QR_Operadores.pdf"
                    >
                        {({ loading }) => (
                            <Button 
                                variant="contained" 
                                color="primary" 
                                disabled={loading}
                                startIcon={loading ? <HourglassEmptyIcon /> : <QrCodeIcon />}
                            >
                                {loading ? "Generando PDF..." : "Descargar QR"}
                            </Button>
                        )}
                    </PDFDownloadLink> */}

                </Box>

            </Grid2>

            {/* TABLA */}

            <Grid2 size={12} marginTop={2}>

                <MiTabla
                    data={operadores}
                    columns={columns}
                    rowClick={handleRowClick}
                />

            </Grid2>

            {/* MODAL PARA EDITAR OPERADOR */}

            <EditarOperador 
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={buscarOperadores}
                data={formValues}
            />

        </Grid2>

    )

}

export default Operadores